module.exports = __webpack_public_path__ + "static/media/talento-digital.24520e26.png";